import { useEffect } from 'react';
import { Link } from 'react-router-dom'; // ✅ Import Link
import AOS from 'aos';
import 'aos/dist/aos.css';
import logo from '../../../assests/images/horizontal.png';
import RequestQuote from '../../mainSection/aboutPage/requestQuote';

const frontendTech = [
  { name: 'React', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg', link: '/technologies/react' },
  { name: 'Vue.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg', link: '/technologies/vue' },
  { name: 'Angular', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg', link: '/technologies/angular' },
  { name: 'HTML5', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg', link: '/technologies/html5' },
  { name: 'CSS3', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg', link: '/technologies/css3' },
  { name: 'JavaScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg', link: '/technologies/javascript' },
  { name: 'TypeScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg', link: '/technologies/typescript' },
];

const backendTech = [
  { name: 'Node.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg', link: '/technologies/node' },
  { name: 'Express.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg', link: '/technologies/express' },
  { name: 'Django', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg', link: '/technologies/django' },
  { name: 'Flask', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original.svg', link: '/technologies/flask' },
  { name: 'Ruby on Rails', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/rails/rails-original-wordmark.svg', link: '/technologies/rails' },
  { name: 'Laravel', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/laravel/laravel-plain.svg', link: '/technologies/laravel' },
  { name: 'Spring Boot', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg', link: '/technologies/spring' },
  { name: 'MongoDB', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg', link: '/technologies/mongodb' },
];

const mobileTech = [
  { name: 'Flutter', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg', link: '/technologies/flutter' },
  { name: 'React Native', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg', link: '/technologies/react-native' },
  { name: 'Swift', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swift/swift-original.svg', link: '/technologies/swift' },
  { name: 'Kotlin', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg', link: '/technologies/kotlin' },
  { name: 'Java', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg', link: '/technologies/java' },
];

const serverTech = [
  { name: 'AWS', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original.svg', link: '/technologies/aws' },
  { name: 'Docker', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg', link: '/technologies/docker' },
  { name: 'Kubernetes', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg', link: '/technologies/kubernetes' },
  { name: 'NGINX', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nginx/nginx-original.svg', link: '/technologies/nginx' },
  { name: 'Firebase', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg', link: '/technologies/firebase' },
];

const TechnologyBox = ({ title, techList, onSelectTech }) => (
  <div className="bg-[#09588D] bg-transparent rounded-lg shadow-lg p-6 relative z-1 border-2  border-[#00A9E6]">
    <h3 data-aos="fade-up" className="text-[30px] 2xl:text-[32px]  lg:text-[26px] font-semibold text-[#09588D] mb-4 text-center font-recoleta">{title}</h3>
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 justify-items-center">
      {techList.map((tech, index) => (
        <div data-aos="fade-up" key={index} className="flex flex-col items-center">
          <button
            key={index}
            type="button"
            onClick={() => onSelectTech(tech.name)}
            className="flex flex-col items-center hover:scale-105 transition-transform duration-300"
            style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
          >
            <img src={tech.icon} alt={tech.name} className="lg:h-12 h-28 lg:w-12 w-28" />
            <span className="mt-2 text-black text-center font-recoleta text-[30px] 2xl:text-[24px]  lg:text-[20px]">{tech.name}</span>
          </button>
          {/* <Link to={RequestQuote} key={index} className="flex flex-col items-center hover:scale-105 transition-transform duration-300">
          <img src={tech.icon} alt={tech.name} className="lg:h-12 h-28 lg:w-12 w-28" />
          <span data-aos="fade-up" className="mt-2 text-black text-center font-recoleta text-[30px] 2xl:text-[24px]  lg:text-[20px]">{tech.name}</span>
        </Link> */}
          {/* // <div data-aos="fade-up" key={index} className="flex flex-col items-center">
        //   <img src={tech.icon} alt={tech.name} className="lg:h-12 h-28 lg:w-12 w-28" />
        //   <span data-aos="fade-up" className="mt-2  text-black text-center font-recoleta text-[30px] lg:text-[20px]">{tech.name}</span> */}
        </div>
      ))}
    </div>
  </div>
);

const TechnologiesSection = ({onSelectTech}) => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="relative py-16 px-4 bg-white overflow-hidden">
      {/* <img
        src={logo}
        alt="TekIT Logo"
        className="absolute inset-0 m-auto opacity-5 w-[85%] h-auto pointer-events-none"
      /> */}
      <h2 className="2xl:text-[40px] lg:text-[32px] text-[40px] font-bold text-center text-[#09588D] mb-12 z-1 relative font-recoleta" data-aos="fade-up">
        Technologies We Are Adept In
      </h2>
      <div className="flex flex-wrap justify-center gap-6 relative z-1">
        <div className="w-full lg:w-[48%]">
          <TechnologyBox title="Frontend Technologies" techList={frontendTech} onSelectTech={onSelectTech}  />
        </div>
        <div className="w-full lg:w-[48%]">
          <TechnologyBox title="Backend Technologies" techList={backendTech} onSelectTech={onSelectTech}  />
        </div>
        <div className="w-full lg:w-[48%]">
          <TechnologyBox title="Mobile Technologies" techList={mobileTech} onSelectTech={onSelectTech}  />
        </div>
        <div className="w-full lg:w-[48%]">
          <TechnologyBox title="Server Technologies" techList={serverTech} onSelectTech={onSelectTech}  />
        </div>
      </div>
    </section>
  );
};

export default TechnologiesSection;


